import { createAsyncThunk } from '@reduxjs/toolkit';
import { GET_PREVIOUSAPPOINTMENT_DETAIL_API_URL } from '@custom/constant';
import axios from 'axios';
import { FetchPreviousAppointmentsParams } from '@custom/Utils/constants/interfaces';

export const PreviousAppointmentsData = createAsyncThunk(
  'patient/fetchPreviousAppointments',
  async ({ uhid, currentTime, limit, pageNumber }: FetchPreviousAppointmentsParams) => {
    try {
      const hospitalId = sessionStorage.getItem('hospitalId') || localStorage.getItem('hospitalId');

      if (!hospitalId) {
        throw new Error('Hospital ID not found in session storage');
      }

      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      if (!token) {
        throw new Error('Authentication token not found');
      }

      const response = await axios.post(GET_PREVIOUSAPPOINTMENT_DETAIL_API_URL, {
        hospitalId,
        uhid,
        currentTime,
        limit,
        pageNumber
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      return response.data;
    } catch (error) {
      return Promise.reject(error.response?.data || error.message || 'An error occurred');
    }
  }
);
